var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.field.multiline
        ? _c("c-textarea", {
            attrs: {
              "floating-label": _vm.field.name,
              clearable: true,
              "required-mark": _vm.field.required,
              "max-length": _vm.maxLength,
              invalid: !!_vm.error,
              error: _vm.error,
            },
            model: {
              value: _vm.localValue,
              callback: function ($$v) {
                _vm.localValue = $$v
              },
              expression: "localValue",
            },
          })
        : _c("c-input", {
            attrs: {
              "floating-label": _vm.field.name,
              clearable: true,
              "required-mark": _vm.field.required,
              "max-length": _vm.maxLength,
              required: _vm.error,
              "required-message": _vm.error,
            },
            model: {
              value: _vm.localValue,
              callback: function ($$v) {
                _vm.localValue = $$v
              },
              expression: "localValue",
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }